<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;padding-top:20px;padding-bottom:20px;"><img alt="" src="media/file0.png" style="width:2.76667in;height:3.74028in"/></p>
<p style="text-indent:0px;">Melek was educated at Bath College, University of Bath, England. She taught shorthand, keyboarding, and English as a second language at Camden Secretarial College, and English at Bath College for foreign students.</p><br/>
<p style="text-indent:0px;">She loves to travel to various countries, meeting people from all walks of life as well as enjoying the beautiful scenery and cultural cuisine.</p><br/>
<p style="text-indent:0px;">Her journeys over the years have brought many memories that include instructing swimming in England and instructing belly dancing in Egypt and the USA for healthy living.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ae7d7f84